import React, { ComponentType, createElement, FunctionComponent, MouseEvent } from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';

interface Props {
  id?: string;
  title: string;
  disabled?: boolean;

  showTitleInButton?: boolean;

  icon: ComponentType<SvgIconProps>;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
}

// Similar to GridItemActionButton, but for the button bar above the navigation panel.  It won't `preventDefault` on
//   click events.
export const ButtonBarButton: FunctionComponent<Props> = (props) =>
  props.showTitleInButton ? (
    <Button
      variant="text"
      color="inherit"
      startIcon={createElement(props.icon)}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.title}
    </Button>
  ) : (
    <Tooltip disableInteractive disableFocusListener title={props.title}>
      <div>
        <IconButton onClick={props.onClick} disabled={props.disabled} size="small">
          {createElement(props.icon)}
        </IconButton>
      </div>
    </Tooltip>
  );
